import Home from '@/views/Home';
import Work from '@/views/Work';
import Project from '@/views/Project';
import About from '@/views/About';
import Blog from '@/views/Blog';
import BlogPost from '@/views/BlogPost';
import Contact from '@/views/Contact';
import Services from '@/views/Services';
import Service from '@/views/Service';
import Impressum from '@/views/Impressum';
import SlugPage from '@/views/SlugPage';
import NotFound from '@/views/NotFound';

export const routes = [
	{
		path: '/',
		name: 'home-de',
		component: Home,
		meta: {
			type: 'home'
		}
	},
	{
		path: '/en/',
		name: 'home-en',
		component: Home,
		meta: {
			type: 'home'
		}
	},
	{
		path: '/service',
		name: 'service',
		component: Services,
		alias: '/en/service',
		meta: {
			type: 'service'
		}
	},
	{
		path: '/service/:slug',
		name: 'serviceitem-de',
		component: Service,
		meta: {
			type: 'serviceitem'
		}
	},
	{
		path: '/en/service/:slug',
		name: 'serviceitem-en',
		component: Service,
		meta: {
			type: 'serviceitem'
		}
	},
	{
		path: '/work',
		name: 'work',
		component: Work,
		alias: '/en/work',
		meta: {
			type: 'work'
		}
	},
	{
		path: '/work/:project',
		name: 'project',
		component: Project,
		alias: '/en/work/:project',
		meta: {
			type: 'project'
		}
	},
	{
		path: '/about',
		name: 'about',
		component: About,
		alias: '/en/about',
		meta: {
			type: 'about'
		}
	},
	{
		path: '/blog',
		name: 'blog',
		component: Blog,
		meta: {
			type: 'blog'
		}
	},
	{
		path: '/blog/:post',
		name: 'blog-post',
		component: BlogPost,
		meta: {
			type: 'blogpost'
		}
	},
	{
		path: '/contact',
		name: 'contact',
		component: Contact,
		alias: '/en/contact',
		meta: {
			type: 'contact'
		}
	},
	{
		path: '/impressum',
		name: 'impressum',
		component: Impressum,
		alias: '/en/impressum',
		meta: {
			type: 'impressum'
		}
	},
	{
		path: '/404',
		name: 'not-found',
		component: NotFound
	},
	{
		path: '/en/404',
		name: 'not-found-en',
		component: NotFound
	},
	{
		path: '/en/*',
		name: 'slugpage-en',
		component: SlugPage,
		meta: {
			type: 'slugpage'
		}
	},
	{
		path: '*',
		name: 'slugpage',
		component: SlugPage,
		meta: {
			type: 'slugpage'
		}
	},
];

export const VueRouterObject = {
	routes,
	mode: 'history',
	saveScrollPosition: false,
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	},
	linkActiveClass: 'is-active',
	linkExactActiveClass: 'is-active-exact'
};

export default VueRouter => new VueRouter(VueRouterObject);



// WEBPACK FOOTER //
// ./src/config/router.js